<style scoped>
  nav {  position: fixed; width: 100%; z-index: 10;  }
  float-left { float: left}
  .perfil {  padding: 5px;  background: #d03074; color: #ffffff;  }
</style>

<template>
  <nav class="navbar has-shadow  animated fadeInDown" v-if="estaLogado" :mobile-modal="false">
    <b-modal :active.sync="isAlterarSenhaActive" has-modal-card>
      <modal-alterar-senha :urlTrocaSenha="urlTrocaSenha"/>
    </b-modal>

    <div class="navbar-brand">
      
      <span class="navbar-item cabecalho-sistema">
        <b-icon :icon="$sistema.icone()"/>
        <span>{{ $sistema.nome() }}</span>
      </span>
      <router-link class="navbar-item" to="/dashboard"><b-icon icon="home"/></router-link>
      <b-dropdown class="navbar-burger burger">
        <button class="button is-primary is-fullwidth" slot="trigger">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <template v-for="itemMenu in menu">
          <b-dropdown-item ><b>{{itemMenu.nome}}</b>
            <template v-for="subItem in itemMenu.sub_menus">
              <router-link class="navbar-item button is-primary m-b-xs" :to="subItem.link"><b>{{subItem.nome}}</b></router-link>
            </template>
          </b-dropdown-item>
        </template>
          <router-link class="navbar-item button is-primary m-r-18 m-l-18" to="/sair"><b>Sair</b></router-link>

      </b-dropdown>

    </div>

    <div class="navbar-menu" :class="{'is-active':menu_ativo}">

      <div class="navbar-start is-left">

        <template v-for="itemMenu in menu">
          <div class="navbar-item has-dropdown is-hoverable">
            <div class="navbar-link">{{itemMenu.nome}}</div>
            <div class="navbar-dropdown is-left">
              <div v-for="subItem in itemMenu.sub_menus" :key="subItem.nome">
                <a
                  v-if="subItem.link === '/boleto_web'"
                  class="navbar-item"
                  href="https://boletopiller.binconsultoria.com.br/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ subItem.nome }}
                </a>
                <a
                  v-else-if="subItem.link === '/manual_boleto'"
                  class="navbar-item"
                  href="https://binconsultoria.com.br/Imagens/PILLER%20-%20MANUAL%20DO%20BOLETOWEB%20-%20v2.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {{ subItem.nome }}
                </a>
                <router-link
                  v-else
                  class="navbar-item"
                  :to="subItem.link"
                >
                  {{ subItem.nome }}
                </router-link>
              </div>
            </div>
          </div>
        </template>

      </div>

      <div class="navbar-end">
        <slot name="notificacao"/>

        <div class="navbar-item has-dropdown is-hoverable">
          <div class="navbar-link">
            {{ usuario.nome }}
          </div>

          <div class="navbar-dropdown is-right">
            <a class="navbar-item" @click.prevent="isAlterarSenhaActive = !isAlterarSenhaActive"
               v-if="parametros.MENU_SISTEMA && parametros.MENU_SISTEMA.indexOf('ALTERAR_SENHA') > -1">
              <b-icon icon="lock"/> <span class="m-l">Trocar senha</span>
            </a>
            <hr class="navbar-divider" v-if="parametros.MENU_SISTEMA && parametros.MENU_SISTEMA.indexOf('ALTERAR_SENHA') > -1">
            <a class="navbar-item" @click.prevent="sair">
              <b-icon icon="power"/> <span class="m-l">Sair</span>
            </a>
          </div>
        </div>

      </div>
    </div>

    <div v-if="emTeste" class="perfil"> Sistema em <br/> {{ $sistema.perfil() }} </div>
  </nav>
</template>

<script>
  import ModalAlterarSenha from '../components/ModalAlterarSenha'

  export default {
    props: ['urlTrocaSenha'],
    components: {ModalAlterarSenha},
    created () {
      this.$root.$on('acessar', () => {
        this.usuario = this.$air.usuarioLogado()
      })
      this.usuario = this.$air.usuarioLogado()
    },
    data () {
      return {
        usuario: {},
        menu_ativo: false,
        isAlterarSenhaActive: false
      }
    },
    methods: {
      sair () {
        this.usuario = null
        this.$air.sair()
        this.$root.$emit('acessar')
      }
    },
    computed: {
      estaLogado () {
        return (this.usuario !== undefined && this.usuario !== null && this.usuario.token !== null && this.usuario.token !== undefined)
      },
      parametros () {
        return this.$store.state.parametros
      },
      menu () {
        return this.$store.state.menu
      },
      emTeste () {
        return this.$sistema.perfil() !== 'Produção'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PortalCabecalho.vue